import { useEffect } from 'react';
import { useStoreActions, useStoreRehydrated } from '@discover-data/stores/restaurant/hooks';

export default function useSyncRegionId(regionId: number) {
  const rehydrated = useStoreRehydrated();
  const setRegionId = useStoreActions((actions) => actions.setRegionId);
  useEffect(() => {
    if (rehydrated) {
      setRegionId(regionId);
    }
  }, [rehydrated, setRegionId, regionId]);
}
